
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 488.4 488.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M477.3 299.6a71.3 71.3 0 01-27.4-35.4 140.2 140.2 0 0038.5-95.5c0-83.9-77.6-151.9-173.3-151.9-85.3 0-156.1 54-170.5 125.2 8.3-1 16.7-1.5 25.2-1.5 107.1 0 194.7 76.8 199 172.6 14.4-4.1 27.9-9.8 40.4-16.9a102.9 102.9 0 0066.2 12c4.4-.4 5.6-6.2 1.9-8.6z","fill":"#205f7f"}}),_c('path',{attrs:{"d":"M169.8 170.1C76.2 170.1 0 237.6 0 320.8c0 31.6 11.3 62.5 31.9 88-3.8 7-9 12.6-15.3 16.8a19 19 0 00-8.2 20.1c1.7 7.7 8 13.5 15.9 14.6a113.4 113.4 0 0061.3-8.6c25.6 13 54.6 19.9 84.2 19.9 93.6 0 169.8-67.6 169.8-150.7s-76.2-150.8-169.8-150.8zm0 271.9c-27.4 0-54.1-6.9-77-19.9l-7.5-4.3-7.4 4.4a68 68 0 01-25.4 8.8 79.4 79.4 0 0010.4-19.8l3.1-8.5-6.1-6.6a110.3 110.3 0 01-30.6-75.5c0-66.9 63-121.2 140.4-121.2s140.5 54.5 140.5 121.4S247.2 442 169.8 442z","fill":"#205f7f"}}),_c('path',{attrs:{"d":"M174.6 287.4c10.2.1 18.6-8.4 18.7-18.8a18.8 18.8 0 10-37.6-.3c0 10.3 8.4 19 18.9 19.1zm22.5 85.2c-1.8.7-3.5 2-5.3 2.7-2.3.9-4.6 1.7-7 2-2.9.3-5-1.2-5.7-4-.5-2.1-.8-4.4-.6-6.5.5-4.5 1.4-8.9 2.2-13.4 2.4-13.4 5-26.8 7.3-40.3.6-3.6 1.3-7.3 1.2-11-.1-4.4-2.7-6.5-7.1-6.5h-35.6a31 31 0 00-4.3.3c-2.7.5-4 1.8-4.2 3.9-.2 1.9.8 3.8 3.3 4.7 2 .7 4.1.9 6.2 1.2 4.8.7 6.4 2.4 6.4 7.3l-.2 2.3-6.2 35.3c-1.1 6.8-2.2 13.5-3.1 20.3-1.4 9.9 8.2 19.3 15.7 20.3 4.5.6 9.1.8 13.7.7a35 35 0 0024.9-11.2c1.2-1.2 2.2-2.9 2.6-4.5.8-2.7-1.4-4.7-4.2-3.6z","fill":"#205f7f"}})])
          )
        }
      }
    